module.exports = __webpack_public_path__ + "static/media/story-1.9d013c2b.jpg";